<template>
  <div>
    <vue-topprogress ref="loadingProgress"></vue-topprogress>
    <div v-if="!loading">
      <h1 class="display-4 font-weight-lighter">
        Product Catalog
      </h1>
      <br />
      <div v-if="!error">
        <iframe ref="productCatalog" :src="src" class="w-100" height="800px" @scroll="scrolling"></iframe>
      </div>
      <b-alert v-else show>{{ error }}</b-alert>
    </div>
  </div>
</template>

<script>

  import Document from "../../models/Document";
  import ToastNotifications from "../../components/shared/mixins/ToastNotifications";

  export default {
  name: 'ProductCatalog',
  mixins: [ToastNotifications],
  data() {
    return {
      loading: true,
      error: null,
      document: null,
      src: null
    };
  },
  methods: {
    init() {
      this.$refs.loadingProgress.start();
      this.loading = true;
      return this.fetch().then(() => {
        return this.populate().then(() => {
          this.error = null;
          this.$refs.loadingProgress.done();
          this.loading = false;
        }, this.defaultError);
      }, this.defaultError);
    },
    fetch() {
      return new Promise((resolve, reject) => {
        return Promise.all([
          Document.api().fetch({name: 'Product Catalog'})
        ]).then((results) => {
          let document_results = results[0];
          if(document_results.entities.documents && document_results.entities.documents.length) {
            this.document = document_results.entities.documents[0];
            return resolve(this.document);
          } else {
            return reject();
          }
        }, () => {
          return reject();
        });
      });
    },
    populate() {
      let p = [Document.api().file(this.document.id, this.document.mime_type)];
      return Promise.all(p).then((responses) => {
        let urlCreator = window.URL || window.webkitURL;
        let document_response = responses[0];
        let document_data = document_response.response.data;
        let document_type = this.document.mime_type;
        let document_file = new Blob([document_data], {type: document_type});
        this.src = urlCreator.createObjectURL(document_file);
      });
    },
    defaultError(err) {
      console.warn(err);
      this.$refs.loadingProgress.done();
      this.loading = false;
      return this.error = 'The product catalog is not available at this moment, please try again later.';
    },
    scrolling() {
      console.log(arguments);
    }
  },
  mounted() {
    this.init();
  }
}
</script>
